/* eslint-disable */
// @ts-nocheck

import { useEffect, useState } from 'react'
import { useController, UseControllerProps } from 'react-hook-form'

import { ExclamationCircleIcon } from '@heroicons/react/20/solid'
import { LockClosedIcon } from '@heroicons/react/24/outline'

interface InputProps {
  label?: string
  placeholder?: string
  type?: 'number' | 'text'
  disabled?: boolean
  size?: number
  textareaClassName?: string
  showInline?: boolean
  className?: string
}

const TextArea = (props: UseControllerProps & InputProps) => {
  const {
    label,
    placeholder,
    disabled,
    size,
    defaultValue,
    textareaClassName,
    showInline,
    className,
  } = props
  const { field, fieldState } = useController(props)

  const [input, setInput] = useState<string>(
    field.value ?? props.defaultValue ?? ''
  )

  useEffect(() => {
    if (defaultValue) {
      field.onChange(defaultValue)
      setInput(defaultValue)
    }
  }, [])

  useEffect(() => {
    if (field.value === undefined) setInput(defaultValue ?? '')
  }, [field.value])

  return (
    <div
      className={`w-full ${showInline ? 'inline-flex items-center gap-2' : 'py-2'}`}
    >
      <label
        className={`${className} block text-sm font-medium ${
          disabled ? 'text-gray-400' : 'text-gray-700'
        }`}
        htmlFor={label}
      >
        <span className="inline-flex items-center">
          {label}
          {disabled && <LockClosedIcon className="h-4 px-2" />}
        </span>
      </label>
      <div className="relative mt-1 w-full rounded-md shadow-sm">
        <textarea
          disabled={disabled}
          {...field}
          className={`${
            fieldState.error
              ? 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500'
              : 'border-slate-400 text-slate-400 focus:border-slate-600 focus:ring-slate-400'
          } block w-full rounded-md pr-10 scrollbar-thin placeholder:text-slate-400 sm:text-sm min-h-[${size}px] ${textareaClassName}`}
          onChange={(e) => {
            field.onChange(e.target.value)
            setInput(e.target.value)
          }}
          placeholder={placeholder && placeholder}
          value={input}
        />

        {fieldState.error && (
          <>
            <div className="pointer-events-none absolute inset-y-0 -top-6 right-0 flex items-center pr-3">
              <ExclamationCircleIcon
                aria-hidden="true"
                className="h-5 w-5 text-red-500"
              />
            </div>

            <p className="mt-2 text-sm text-red-600">
              {fieldState.error?.message}
            </p>
          </>
        )}
      </div>
    </div>
  )
}

export default TextArea
